<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    dataset: {
      type: Array,
      default: () => [],
    },
    defaultDataset: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chartData: {
        labels: this.headers,
        datasets: this.defaultDataset,
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                min: 0,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    console.log(this.defaultDataset);
    this.renderChart(this.chartData, this.options);
  },
  methods: {
    update() {
      this.chartData.datasets = this.dataset;
      this.renderChart(this.chartData, this.options);
    },
  },
};
</script>
